import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LocalizedSchemaService } from '../../../services/localized-schema.service';

@Component({
  selector: 'app-crm',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './crm.component.html',
  styleUrl: './crm.component.scss'
})
export class CRMComponent implements OnInit, OnDestroy {
  private readonly schemaId = 'crm-product-schema';

  constructor(@Inject(DOCUMENT) private document: Document, private schema: LocalizedSchemaService) { }

  ngOnInit(): void {
    if (this.document.getElementById(this.schemaId)) {
      return;
    }

    const script = this.document.createElement('script');
    script.id = this.schemaId;
    script.type = 'application/ld+json';
    script.text = this.schema.serialize({
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'SoftwareApplication',
          name: $localize`AlbCode CRM`,
          applicationCategory: 'BusinessApplication',
          operatingSystem: $localize`Webbrowser, Android`,
          url: 'https://www.albcode.de/albcode/crm/',
          description: $localize`Webbasiertes CRM für Kunden, Projekte, Aufgaben, E-Mails und Dokumente mit Teamkalender, Projektzeiterfassung und nativer Android-Kalender-App.`,
          featureList: [
            $localize`Kunden- und Kontaktverwaltung`,
            $localize`Projekt-, Vorgangs- und Aufgabenmanagement`,
            $localize`Integrierter E-Mail-Ein- und Ausgang`,
            $localize`Teamkalender mit Einladungen und Erinnerungen`,
            $localize`Projektbezogene Zeiterfassung und Auswertung`,
            $localize`Native Android-App für den Kalender`,
            $localize`Dokumenten- und Notizverwaltung`,
            $localize`Offene API für Integrationen`
          ],
          provider: {
            '@type': 'Organization',
            name: $localize`AlbCode – Software & Webentwicklung Saliger`,
            url: 'https://www.albcode.de/'
          }
        },
        {
          '@type': 'FAQPage',
          mainEntity: [
            {
              '@type': 'Question',
              name: $localize`Hat das AlbCode CRM einen integrierten Kalender?`,
              acceptedAnswer: {
                '@type': 'Answer',
                text: $localize`Ja. Termine lassen sich im Teamkalender planen, bearbeiten und mit Teilnehmern, Einladungen und Erinnerungen organisieren.`
              }
            },
            {
              '@type': 'Question',
              name: $localize`Kann ich Arbeitszeiten im CRM erfassen?`,
              acceptedAnswer: {
                '@type': 'Answer',
                text: $localize`Ja. Projektzeiten können mit Zeitraum, Dauer, Tätigkeit, Benutzer und Abrechenbarkeit erfasst und ausgewertet werden.`
              }
            },
            {
              '@type': 'Question',
              name: $localize`Gibt es eine Android-App für den CRM-Kalender?`,
              acceptedAnswer: {
                '@type': 'Answer',
                text: $localize`Ja. Die native Android-App bietet Tag-, Wochen-, Monats- und Agendaansichten sowie das Erstellen und Bearbeiten von Terminen und lokale Erinnerungen.`
              }
            }
          ]
        }
      ]
    });
    this.document.head.appendChild(script);
  }

  ngOnDestroy(): void {
    this.document.getElementById(this.schemaId)?.remove();
  }
}
